import { Box, Text } from '@chakra-ui/react'
import {
    type ContentPlaceholderProps,
  } from './content-placeholder'
import { useColorPalette } from './ui/color-palette-context';
import config from '../config.json';
  
  export const Footer = (props: ContentPlaceholderProps) => {
    const { colorPalette } = useColorPalette();

    return (
      <Box height={'24px'} pl={'30px'} pr={'30px'} bgColor={`${colorPalette}.solid`} display={'flex'} justifyContent={'space-between'} alignItems={'center'} >
        <Text mb={0} fontSize={'sm'} color={'white'}>Version {config.version}</Text>
        <Text fontSize={'sm'} color={'white'}>© 2025 NYS Office of Information Technology Services</Text>
      </Box>
    )
  }
  